import React from 'react'

import rotateIcon from '../assets/icon-rotate.png'
import './RotateNotification.scss'

const RotateNotification = () => {
  return (
    <div className='rotate-notification'>
      <span className='rotate-notification__icon' style={{ backgroundImage: `url(${rotateIcon})` }} />
      <div className='rotate-notification__text'>
        Please Rotate Your Device
      </div>
    </div>
  )
}

export default RotateNotification



// WEBPACK FOOTER //
// ./src/templates/shared/components/RotateNotification.js